import styled from 'styled-components';

export const StyledStudentMainPage = styled.div`
  width: 100%;
  height: 100%;
`;